/** @jsx h */
import { h, Component, JSX, VNode } from 'preact';
import CustomizedControl from '../../../../../../common/components/customized-control';

interface CtaConfig {
  backgroundColor: string;
  labelColor: string;
}

interface CtaItemProps {
  cta: CtaConfig;
  onClick: (e: MouseEvent) => void;
}

interface CtaItemContext {
  translate: (key: string) => string;
}

export class CtaItem extends Component<CtaItemProps> {
  context!: CtaItemContext;

  constructor(props: CtaItemProps, context: CtaItemContext) {
    super(props, context);
  }

  render(): JSX.Element {
    const { cta, onClick } = this.props;

    return (
      <div data-zone="cta">
        <CustomizedControl
          id="cta"
          onTouchStart={(e: TouchEvent) => e.stopPropagation()}
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
            onClick(e);
          }}
          controlStyle={{
            backgroundColor: cta.backgroundColor,
            backgroundOpacity: 1,
            labelColor: cta.labelColor,
            labelOpacity: 1
          }}
          style={{
            fontWeight: 'bold',
            padding: '0 12px',
            minWidth: '64px',
            display: 'flex',
            justifyContent: 'center'
          }}
          fontSize={14}
        >
          {this.context.translate('call_to_action')}
        </CustomizedControl>
      </div>
    );
  }
}
